import { useLoaderData } from "react-router";
import CustomError from "@components/Error/CustomError";
import { MetaTagDescriptor } from "@components/MetaTags/MetaTags";
import { Route } from "@route-types/Newsletter/Archive/+types/NewsletterArchivePage";
import { fetchNewsletterArchivePageData } from "@routes/Newsletter/Archive/NewsletterArchivePage.server";
import NewsletterArchivePageContent from "@routes/Newsletter/Archive/NewsletterArchivePageContent";
import { NewsletterArchiveContext } from "@routes/Newsletter/Archive/utils/types";
import { ResponseType } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

/** This is the main entry point component for /keywords/:keyword route. */
const NewsletterArchivePage = (): React.ReactElement => {
  const context = useLoaderData<NewsletterArchiveContext>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return <NewsletterArchivePageContent {...context.payload.data} />;
};

export default NewsletterArchivePage;

export const loader = async ({ request }: Route.LoaderArgs) => {
  const url = new URL(request.url, `http://localhost`);
  const path = url.pathname;
  const relativePath = path.replace(/^\/newsletter-archive/, "") || "/";

  return await fetchNewsletterArchivePageData(relativePath);
};

export const meta = ({ loaderData }: Route.MetaArgs): MetaTagDescriptor[] => {
  const context = loaderData as NewsletterArchiveContext;
  if (context.type !== ResponseType.SUCCESS) return [];

  const data = context.payload;

  if (!data) return [];
  if (!data.metaTags) return [];

  return data.metaTags;
};
